import type { IconSvgObject } from './types';

const TextBoldIcon: IconSvgObject = [
  ["path", { d: "M5.5 12H13C15.4853 12 17.5 9.98528 17.5 7.5C17.5 5.01472 15.4853 3 13 3H5.5V12ZM5.5 12H14C16.4853 12 18.5 14.0147 18.5 16.5C18.5 18.9853 16.4853 21 14 21H5.5V12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TextBoldIcon;
